import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpServiceService } from 'src/app/http-service.service';
import { UtilService } from 'src/app/util.service';
import { LoaderService } from 'src/app/loader.service';
import { AlertService } from 'src/app/alert.service';


@Component({
  selector: 'app-certificate-type-edit',
  templateUrl: './certificate-type-edit.component.html',
  styleUrls: ['./certificate-type-edit.component.scss']
})
export class CertificateTypeEditComponent implements OnInit {

  certificateTypeForm: FormGroup;
  editDetails;
  constructor(private formBuilder:FormBuilder, private router:Router,
  public util:UtilService,
    public httpService:HttpServiceService, public alertService:AlertService,
    public loaderService:LoaderService) {
    
  }

  ngOnInit() {
    this.certificateTypeForm = this.formBuilder.group({
      id: ['', [Validators.required]],
              serviceType: ['', [Validators.required]],
                certificateType: ['', [Validators.required]],
                isAvailable: ['', [Validators.required]],
            });
    this.loaderService.showLoader('Please wait while fetching ..').then(()=>{
    
    this.editDetails = JSON.parse(localStorage.getItem('editData'))
    this.certificateTypeForm.patchValue(this.editDetails);
    this.loaderService.hideLoader();
  })

  }

  submit(data) {
    data['createdAt']= new Date().getTime();
    this.loaderService.showLoader('Updating Please wait ..').then(()=>{
      try{
        this.httpService.postApi(data, 'certificateType/edit/' + data.id).subscribe((res: any) => {
          this.loaderService.hideLoader();
          if (res["success"]) {
            this.alertService.presentAlert('Success','Successfully updated','Okay');
            this.router.navigate(['/certificateType-list'])
          } else {
            this.alertService.presentAlert('Error',res["error"]["message"],'Okay');
          }
        },(err)=>{
          
          this.loaderService.hideLoader();
          this.alertService.presentNetworkAlert();
         });    
      }catch(e){
        this.loaderService.hideLoader();
        this.alertService.presentAlert('Error','Something went wrong please try again','Okay');
      }
    })
    
  }

}
